module.exports = __webpack_public_path__ + "static/media/rebirth_25.372243ce.jpg";